import { Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationHeaderLocationDeleted } from '../../../stores/locations/locations.actions';
import { selectCurrentLocation } from '../../../stores/locations/locations.selector';

@Component({
  selector: 'era-location-delete-modal',
  templateUrl: './location-delete-modal.component.html',
  imports: [],
})
export class LocationDeleteModalComponent {
  private readonly store = inject(Store);
  public readonly activeModal = inject(NgbActiveModal);

  public readonly location = this.store.selectSignal(selectCurrentLocation);

  deleteLocation() {
    const location = this.location();
    if (!location) {
      return;
    }

    this.store.dispatch(new LocationHeaderLocationDeleted(location));
    this.activeModal.close();
  }
}
